import { WINDOW_EVENTS } from '../event_bus_modules/window';

$(() => {
  const $body = $('body');
  const $menu = $('#expandable-menu');

  const MENU_EXPANDED_CLASS = 'menu-expanded';

  const onShowMenu = () => {
    $body.addClass(MENU_EXPANDED_CLASS);
  };

  const onHideMenu = () => {
    $body.removeClass(MENU_EXPANDED_CLASS);
  };

  const onRandomGlobalClick = (target) => {
    const isOutsideOfMenu = !$menu.has(target).length;

    if (isOutsideOfMenu) {
      $menu.collapse('hide');
    }
  };

  EVENT_BUS.on(WINDOW_EVENTS.RANDOM_CLICK, ({ target }) =>
    onRandomGlobalClick(target)
  );

  $menu.on('show.bs.collapse', onShowMenu);
  $menu.on('hide.bs.collapse', onHideMenu);
});
